import {SchemaTag} from 'folder-items/FileConstants';
import {isIntegrationField} from 'schemas/fields/integration/IntegrationFieldUtil';

export function isIntegrationTag(tag: SchemaTag): boolean {
  return tag.tagSchemaField && isIntegrationField(tag.tagSchemaField);
}

export function hasIntegrationTags(tags: Array<SchemaTag>): boolean {
  return tags.some((tag) => isIntegrationTag(tag));
}
